import {Component, Input} from '@angular/core';

@Component({
  selector: 'lib-app-group-input',
  templateUrl: './lib-group-input.component.html',
  styleUrls: ['./lib-group-input.component.scss']
})
export class LibGroupInputComponent {

  @Input() label = '';

}
